<template>
  <div class="withdraw-record-box">
    <van-nav-bar title="提现记录" fixed left-arrow @click-left="$router.go(-1)" />
    <van-cell-group>
  <van-cell v-for="item in withdrawList" :key="item.Id"
     :title="item.money/100+'元'" :value="statuList[item.status]" :label="format(item.add_time)" />
</van-cell-group>
<van-empty v-if="withdrawList.length === 0" description="暂无数据" />
  </div>
</template>


<script>
export default {
  data() {
    return {
      withdrawList: [],
      page: 1,
      total: 10,
      statuList:{
        '0':'提现中',
        '1':'提现成功',
        '2':'提现失败',
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 加载数据
    loadData() {
      this.Post({}, "/main/withdrawList", res => {
        if (res.states == 1) {
          this.withdrawList = res.data.list;
          this.total = res.data.total;
          this.page = res.data.page;
        } else {
          this.Toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.withdraw-record-box{
  padding: 46px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/mine/withdrawRecord.vue